<template>
  <div class="admin-set">
    <div class="top-warp">
      <el-input prefix-icon="el-icon-search" style="margin-right: 15px; width: 300px" v-model="searchInfo.tel" placeholder="请输入手机号码或者姓名" clearable=""/>
      <el-button  type="primary" @click="searchClick">搜索</el-button>
    </div>
    <div style="margin-top: 20px">
      <el-button type="primary" @click="openDialog">添加</el-button>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="userName" label="姓名" width=""></el-table-column>
        <el-table-column prop="tel" label="管理后台登录账号" width=""></el-table-column>
        <el-table-column prop="roleId" :formatter="formatRoleId" label="权限"></el-table-column>
        <el-table-column prop="createTime" label="添加日期" width=""></el-table-column>
        <el-table-column prop="createTime" label="删除状态" width="">
          <template slot-scope="{row}">
            <span v-if="row.isDelete === 0">正常</span>
            <span v-else style="color: #F56C6C;">已删除</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作" width="">
          <template slot-scope="{row}">
            <el-button size="mini" @click="editRole(row)">编辑</el-button>
            <el-button v-if="row.isDelete === 0" size="mini" type="danger" @click="delAdminItem(row)">删除</el-button>
            <el-button v-else size="mini" @click="restoreItem(row)">恢复</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
        style="margin-top: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchInfo.pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="searchInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" center :close-on-click-modal="false">
      <el-form label-width="140px" :model="addFrom" :rules="addFromRules" ref="addFromRef">
        <el-form-item v-if="isAdd" label="管理后台登录账号:" prop="adminUserId">
          <el-select v-model="addFrom.adminUserId" filterable remote :remote-method="remoteUsername" :loading="loadingUserName" reserve-keyword placeholder="请输入管理后台登录账号" style="width: 100%">
            <el-option v-for="item in userNameList" :key="item.adminUserId" :label="item.username" :value="item.adminUserId" />
          </el-select>
        </el-form-item>
        <el-form-item v-else label="管理后台登录账号:" prop="adminUserId">
          <el-input v-model="addFrom.tel" disabled></el-input>
        </el-form-item>
        <el-form-item label="账户类型:" prop="roleId">
          <el-select v-if="selectOptions.length!=0" style="width: 100%" v-model="addFrom.roleId" placeholder="请选择管理员类型">
            <el-option
                v-for="item in selectOptions"
                :key="item.id"
                :label="item.roleName"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="isAdd" type="primary" @click="confirmClick(1)">确 定</el-button>
        <el-button v-else type="primary" @click="confirmClick(2)">修 改</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { backupQueryAdminUser, backUserRoleBackupAdd, userRoleBackupRestore } from "@/utils/api";

export default {
  name: "backAdminSet",
  data() {
    return {
      searchInfo: {
        tel: '',
        pageSize: 10,
        pageNum: 1,
      },
      total: 10,
      tableData: [],
      dialogVisible: false,
      addFrom: {
        adminUserId: '',
        roleId: '',
      },
      // 用户列表
      userNameList: [],
      loadingUserName: false,
      selectOptions: [],
      dialogTitle: '',
      isAdd: true,
      isDisabled: false,
      addFromRules: {
        adminUserId: [
          { required: true, message: '请选择管理后台登录账号', trigger: 'blur' },
        ],
        roleId: [
          { required: true, message: '请选择管理员类型' },
        ]
      }
    }
  },
  created() {
    this.getRoleList()
    this.allRoleList()
  },
  methods: {
    userRoleBackupRestore,
    // 远程搜索手机号
    async remoteUsername(query) {
      this.userNameList = []
      if (!query) return
      this.loadingUserName = true
      const [err, res] = await backupQueryAdminUser(query)
      if (err) return
      this.userNameList = res
      this.loadingUserName = false
    },
    searchClick() {
      this.getRoleList()
    },
    openDialog() {
      this.dialogTitle = '添加'
      this.dialogVisible = true
      this.isDisabled = false
      this.isAdd = true
      this.addFromRules.adminUserId[0].required = true

      // // 重置表单
      this.addFrom =  {
        adminUserId: '',
        roleId: '',
      }
      this.$refs.addFromRef.resetFields()
    },
    confirmClick(type) {
      this.$refs['addFromRef'].validate((valid) => {
        if (valid) {
          if (type == 1) {
            this.addRole()
          }
          else if (type == 2) {
            this.actRole()
          }
        }
      });
    },
    // 编辑权限
    editRole({id, tel, roleId}) {
      this.dialogTitle = '编辑'
      this.dialogVisible = true
      this.isDisabled = true
      this.isAdd = false
      this.addFromRules.adminUserId[0].required = false

      this.addFrom =  {id, tel, roleId: roleId ? roleId : ''}
      this.$refs.addFromRef.resetFields()
    },
    // 删除
    delAdminItem({id}) {
      this.$confirm('此操作将删除该管理员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRole(id)
      }).catch(() => {
      });
    },

    // 恢复
    async restoreItem({id}) {
      const [err, res] = await userRoleBackupRestore({id})
      if (err) return
      this.$message.success('操作成功')
      await this.getRoleList()
    },
    handleSizeChange(val) {
      this.searchInfo.pageSize = val
      this.getRoleList(' ');
    },
    handleCurrentChange(val) {
      this.searchInfo.pageNum = val
      this.getRoleList(' ');
    },
    formatRoleId({roleId}) {
      let d = this.selectOptions.find(item => item.id == roleId)
      return d&&d.roleName
    },
    // 获取列表
    async getRoleList(val) {
      if (val && val.length > 0) {
        console.log();
      }else{
        this.searchInfo.pageNum = 1;
      }
      let res = await this.$request.roleList(this.searchInfo)
      // console.log('list', res)
      if (res.status == 200) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    },
    async addRole() {
      let [err, res] = await backUserRoleBackupAdd(this.addFrom)
      if (err) return
      this.dialogVisible = false
      this.$message.success('添加成功')
      await this.getRoleList()

    },
    async actRole() {
      delete this.addFrom.tel
      let res = await this.$request.editRole(this.addFrom)
      if (res.status == 200) {
        this.$message.success('修改成功')
        await this.getRoleList(' ');
      } else {
        this.$message.error(res.message)
      }
      this.dialogVisible = false
    },
    async deleteRole(id) {
      let res = await this.$request.deleteRole({id})
      if (res.status == 200) {
        this.$message.success('删除成功')
        await this.getRoleList()
      } else {
        this.$message.error(res.message)
      }
    },

    async allRoleList() {
      let res = await this.$request.allRoleList()
      if (res.status === 200) {
        this.selectOptions = res.data
      }
    }
  }
}
</script>

<style lang="less">
.admin-set {
  width: 100%;
  padding: 20px;
}
</style>